import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid/Grid';
import { showNotification, translate, withDataProvider } from 'react-admin';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import SubscriptionSummary from './SubscriptionSummary';
import SubscriptionBilling from './SubscriptionBilling';
import { getAccountId, getTokenField } from '../../../token';
import { getSummaryProducts, serializeProducts } from '../../../utils/index';
import withStyles from '@material-ui/core/styles/withStyles';
import { externalRedirect } from '../../../utils';

const styles = () => ({
  title: {
    paddingTop: '52px !important',
    paddingBottom: '68px !important',
    textAlign: 'center',
    '&& > h2': {
      color: '#212322',
      fontSize: 24,
      marginBottom: 10,
      fontWeight: 400,
    },
    '&& > h3': {
      color: 'rgba(33,35,34,0.5)',
      fontSize: 14,
      textTransform: 'none',
      fontWeight: 400,
    },
  },
  progressBar: {
    flex: '1',
    alignSelf: 'center',
  },
});


class Subscription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      complianceDashboardPlan: {},
      isBillingInfo: false,
      paymentPeriod: 'year',
      products: null,
      isSaved: false,
      loading: true,
      pendingSubmit: false,
    };
    ({ dataProvider: this.dataProvider } = this.props);
  }

  componentDidMount() {
    this.dataProvider.getList(`accounts/${getAccountId()}/available-subscriptions`, {
      pagination: {
        page: 1,
      },
      sort: {
        field: 'date',
        order: 'DESC',
      },
      filter: {
        itemsPerPage: 1000,
      },
    })
      .then(({ data }) => {
        let products = serializeProducts(data, this.state.paymentPeriod);
        this.setState({ ...products, loading: false });
      })
      .catch(error => {
        console.error({ error });
      });
    this.setIsBillingInfo(false);
  }

  setIsBillingInfo(isBillingInfo) {
    this.setState((prevState) => {
      const { location, replace } = this.props.history;
      replace({ pathname: location.pathname, search: `?step=${isBillingInfo ? 'checkout' : 'plan'}` });
      return { ...prevState, isBillingInfo };
    });
  }

  changePeriod() {
    let complianceDashboardPlan = {};

    if (this.state.complianceDashboardPlan.name === 'compliance_dashboard_basic') {
      complianceDashboardPlan = this.state.products[this.state.paymentPeriod].compliance_dashboard.prices[0];
    } else if (this.state.complianceDashboardPlan.name === 'compliance_dashboard_advanced') {
      complianceDashboardPlan = this.state.products[this.state.paymentPeriod].compliance_dashboard.prices[1];
    } else {
      complianceDashboardPlan = this.state.products[this.state.paymentPeriod].compliance_dashboard.prices[1];
    }

    this.setState(state => ({
      paymentPeriod: state.paymentPeriod === 'year' ? 'month' : 'year',
      complianceDashboardPlan: complianceDashboardPlan,
    }));
  }

  submit(event) {
    this.setState({ pendingSubmit: true });

    const { billing, cardToken } = event;
    const stripeCoupon = billing.coupon ? billing.coupon : null;
    const { showNotification } = this.props;
    const context = this;

    const payload = {
      customer: {
        shippingAddressLineSecond: '',
        metadataAtt: '',
        ...billing,
        account: `/accounts/${getAccountId()}`,
        paymentMethod: cardToken,
      },
      billingInterval: this.state.paymentPeriod,
      complianceDashboardAccess: this.state.complianceDashboardPlan.name,
      collectionMethod: 'charge_automatically',
      coupon: stripeCoupon,
    };
    delete payload.customer['coupon'];

    this.dataProvider.create('subscriptions', { data: payload }).then(({ data }) => {
      if (data.pendingSetupIntentStatus === 'requires_action') {
        event.stripe.handleCardSetup(data.pendingSetupIntentSecret).then(function(result) {
          if (result.setupIntent && result.setupIntent.status === 'succeeded') {
            showNotification('Your subscription has successfully started!');

            context.setState({ isSaved: true });


            setTimeout(function() {
              window.location.reload();
            }, 2000);

          } else if (result.error) {
            showNotification(result.error.message, 'warning');


            setTimeout(function() {
              context.props.history.push('/account');
            }, 2000);

          }
        });
      } else if (data.latestInvoicePaymentIntentStatus === 'requires_action') {
        event.stripe.handleCardPayment(data.latestInvoicePaymentIntentSecret).then(function(result) {
          if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
            showNotification('Your subscription has successfully started!');

            context.setState({ isSaved: true });

            setTimeout(function() {
              window.location.reload();
            }, 2000);

          } else if (result.error) {
            showNotification(result.error.message, 'warning');

            setTimeout(function() {
              context.props.history.push('/account');
            }, 2000);

          }
        });
      } else if (data.latestInvoicePaymentIntentStatus === 'requires_payment_method') {
        showNotification('Something went wrong with the payment. Charging failed.', 'warning');

        setTimeout(function() {
          context.props.history.push('/account');
        }, 2000);

      } else {
        showNotification('Your subscription has successfully started!');

        context.setState({ isSaved: true });

        setTimeout(function() {
          window.location.reload();
        }, 2000);
      }
    }).catch(error => {
      if (error.message) {
        showNotification(error.message, 'warning');
      } else {
        showNotification(JSON.stringify(error), 'warning');
        console.error('Error during subscription save: ', JSON.stringify(error));
      }
      context.setState({ pendingSubmit: false });
    });
  }

  render() {
    externalRedirect('subscription');
    return (<></>);
    const { classes, translate } = this.props;
    const { isBillingInfo, paymentPeriod, complianceDashboardPlan, products, isSaved } = this.state;
    const title = `summary.${isBillingInfo ? 'billing' : 'products'}_title`;
    const subtitle = `summary.${isBillingInfo ? 'billing' : 'products'}_subtitle`;
    const summaryProducts = getSummaryProducts(paymentPeriod, products, complianceDashboardPlan);
    const isStripe = getTokenField('payment_method') === 'stripe';
    const redirect = isSaved || getTokenField('subscription_type') === 'stripe_based_started' || !isStripe;

    return (
      this.state.loading ? <CircularProgress className={classes.progressBar} variant="indeterminate"/> :
        <Grid container spacing={0}>
          {redirect ? <Redirect to={'/websites'}/> : null}
          <Grid item xs={12} className={classes.title}>
            <Typography variant="h6">{translate(title)}</Typography>
            <Typography variant="subtitle1">{translate(subtitle)}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              {
                isBillingInfo ? <SubscriptionBilling
                  paymentPeriod={paymentPeriod}
                  sum={summaryProducts.sum}
                  currency={summaryProducts.currency}
                  onEdit={() => {
                    this.setIsBillingInfo(false);
                  }}
                  onCancel={() => {
                    this.setState({ isSaved: true });
                  }}
                  onSubmit={event => this.submit(event)}
                  pendingSubmit={this.state.pendingSubmit}
                /> :
                  <SubscriptionSummary paymentPeriod={paymentPeriod}
                    products={products}
                    summaryProducts={summaryProducts}
                    complianceDashboardPlan={complianceDashboardPlan}
                    onPeriodChange={() => this.changePeriod()}
                    onPlanChange={complianceDashboardPlan => {
                      this.setState({ complianceDashboardPlan });
                    }}
                    onSubmit={() => {
                      this.setIsBillingInfo(true);
                    }}/>
              }
            </Grid>

          </Grid>
        </Grid>
    );
  }
}

export const SubscriptionPage = withStyles(styles)(
  translate(connect(null, { showNotification })(withDataProvider(withRouter(Subscription)))),
);
